import { AuthActions } from "../LoginRedux/Action";
import { CancelOrderActions } from "./action";

let cancelOrderState = {
  cancelMsg: null,
  cancelError: null,
  smsTemplate: null,
  smsTemplateError: null,
};

export const cancelOrderReducer = (
  state = cancelOrderState,
  { type, payload }
) => {
  switch (type) {
    case CancelOrderActions.CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        cancelMsg: payload,
        cancelError: null,
      };

    case CancelOrderActions.CANCEL_ORDER_FAILURE:
      return {
        ...state,
        cancelMsg: null,
        cancelError: payload,
      };

    case CancelOrderActions.SEND_SELECTED_SMS_SUCCESS:
      return { ...state, smsTemplate: payload, smsTemplateError: null };

    case CancelOrderActions.SEND_SELECTED_SMS_FAILURE:
      return { ...state, smsTemplate: null, smsTemplateError: payload };

    case AuthActions.Logout_User:
      return {
        cancelMsg: null,
        cancelError: null,
        smsTemplate: null,
        smsTemplateError: null,
      };
    default:
      return state;
  }
};
